import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITaskCatalog } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TaskCatalogService extends ODataService<ITaskCatalog, number> {
    protected _endpoint: string;

    constructor(http: HttpClient) {
        super(http, MapperService.taskCatalogMapper);
        this._endpoint = '/odata/TaskCatalogs';
    }

    public add(data: ITaskCatalog): Observable<ITaskCatalog> {
        const serverData = this._toPoco(data, MapperService.taskCatalogRequestMapper);
        const payload = JSON.stringify(serverData);
        const url = `${this._endpoint}/UiPath.Server.Configuration.OData.CreateTaskCatalog`;
        return this._http
            .post(url, payload)
            .pipe(
                map(res => this._mapData<ITaskCatalog>(res, MapperService.taskCatalogMapper)),
            ) as Observable<ITaskCatalog>;
    }

    public update(key: number, data: ITaskCatalog): Observable<Object> {
        const serverData = this._toPoco(data, MapperService.taskCatalogRequestMapper);
        const payload = JSON.stringify(serverData);
        const url = `${this._endpoint}(${key})/UiPath.Server.Configuration.OData.UpdateTaskCatalog`;
        return this._http
            .post(url, payload, {
                headers: this._jsonHeaders,
            });
    }
}
